<template>
    <div class="detail-root">
        <div v-if="manuals" class="detail-wrapper">
            <div class="detail-top"></div>
            <div class="detail-bottom">
                <div class="detail-left">
                    <!-- Current Manuals List goes here -->
                    <div class="detail-manual-list-wrapper">
                        <ScrollPanel
                            class="detail-scroll-panel"
                            style="height: 81.25vh;"
                        >
                            <item-tile
                                v-for="(manual, index) in manuals"
                                :key="index"
                                :data="manual"
                                :isActive="
                                    currentManual && manual == currManual
                                "
                                class="detail-item-tile"
                                @tileClick="onTileClick"
                            />
                        </ScrollPanel>
                    </div>
                </div>
                <div class="detail-right">
                    <div v-if="currManual" class="detail-display-wrapper">
                        <div class="detail-display-header">
                            <div class="detail-display-header-left">
                                <span class="detail-display-title">
                                    {{ currManual.title }}
                                </span>
                            </div>
                            <div class="detail-display-header-right">
                                <!--
                <span @click="onSaveClick" class="detail-display-control detail-display-control-save">
                  <span class="detail-display-icon-wrapper">
                    <i class="pi pi-save"></i>
                  </span>
                </span>
                -->
                                <span
                                    v-if="currManual.download_pdf_url"
                                    class="detail-display-control detail-display-control-print"
                                >
                                    <span
                                        @click="onPrintClick"
                                        class="detail-display-icon-wrapper"
                                    >
                                        <i class="pi pi-print"></i>
                                    </span>
                                </span>
                                <span
                                    v-if="currManual.download_pdf_url"
                                    class="detail-display-control detail-display-control-download"
                                >
                                    <a
                                        :download="
                                            currManual.title
                                                ? currManual.title
                                                : 'manual'
                                        "
                                        :href="currManual.download_pdf_url"
                                    >
                                        <span
                                            class="detail-display-icon-wrapper"
                                        >
                                            <i class="pi pi-download"></i>
                                        </span>
                                    </a>
                                </span>
                            </div>
                        </div>
                        <div class="detail-display-viewer">
                            <!-- Display / PDF Viewer Goes here -->
                            <div
                                v-if="currManual && currManual.download_pdf_url"
                            >
                                <PDFViewer
                                    id="mv-pdfViewer"
                                    ref="pdfViewer"
                                    :key="viewerReloadKey"
                                    :fileUrl="currManual.download_pdf_url"
                                />
                            </div>
                            <div
                                v-else-if="currManual && currManual.url"
                                class="detail-display-no-manual"
                            >
                                <div class="detail-display-background"></div>
                                <div class="detail-display-overlay-wrapper">
                                    <div class="detail-display-overlay">
                                        <div
                                            class="detail-display-overlay-title"
                                        >
                                            {{ currManual.title }}
                                        </div>
                                        <div
                                            class="detail-display-overlay-text"
                                        >
                                            To view {{ currManual.title }} visit
                                            {{ currManualFormattedUrl }}. Click
                                            "Open PDF" below.
                                        </div>
                                        <div
                                            class="detail-display-overlay-button-wrapper"
                                        >
                                            <a
                                                class="detail-display-overlay-button-link"
                                                :href="currManual.url"
                                                target="_blank"
                                            >
                                                <div
                                                    class="detail-display-overlay-button"
                                                >
                                                    Open Manual
                                                    <i
                                                        class="detail-display-overlay-button-icon pi pi-external-link"
                                                    ></i>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItemTile from "../../../../components/itemTile/ItemTile.vue";
import ScrollPanel from "primevue/scrollpanel";
import PDFViewer from "../../../../components/pdfViewer/index.vue";

export default {
    name: "detail",
    props: ["manuals", "currentManual"],
    components: {
        ItemTile,
        ScrollPanel,
        PDFViewer,
    },
    data() {
        return {
            currManual: this.currentManual || null,
            viewerReloadKey: 0,
        };
    },
    mounted() {},
    computed: {
        currManualFormattedUrl() {
            if (this.currManual && this.currManual.url) {
                try {
                    const url = new URL(this.currManual.url);
                    return url.host;
                } catch (e) {
                    console.error(e);
                    return this.currManual.url;
                }
            } else return null;
        },
    },
    watch: {
        currentManual(nv) {
            this.currManual = nv;
        },
        currManual() {
            this.viewerReloadKey++;
        },
    },
    methods: {
        onTileClick(manual) {
            this.currManual = manual;
        },
        onSaveClick() {
            // Not yet implemented
            console.log("Save clicked");
        },
        onPrintClick() {
            if (this.$refs?.pdfViewer != undefined) {
                const name = this.currManual.title
                    ? this.currManual.title
                    : "manual";
                this.$refs.pdfViewer.printPDF(name);
            }
        },
        onDownloadClick() {
            // Do we want to track download clicks?
        },
    },
};
</script>

<style src="./detail.css"></style>
